module.exports = __webpack_public_path__ + "img/Spanish.95833692.svg";